import { createContext } from 'react';

/**
 * Set to `true` by <LayoutContainer> (which MainLayout / DemoLayout use) to mark
 * that page content is rendered inside a layout that already applies the global
 * Layout Preferences (Content Width + Horizontal Padding from Settings).
 *
 * When true, the themed <Container> defers its own width/horizontal-padding to
 * that managed layout, so EVERY page conforms to the global preference even if
 * the page wraps itself in its own <Container size="...">. Outside a managed
 * layout (e.g. auth / onboarding screens) Container behaves normally.
 */
export const LayoutManagedContext = createContext(false);
